import getAutomaticRepliesOptionStateDefaultValue from './getAutomaticRepliesOptionStateDefaultValue';
import { getDisplayDate } from 'owa-datetime';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
/**
 * Utility function to parse mailbox auto reply configuration options
 * @returns state of type AutomaticRepliesOptionState
 */
export default function parseMailboxAutoReplyConfiguration(mailboxAutoReplyConfigurationOptions) {
    var optionState = getAutomaticRepliesOptionStateDefaultValue();
    optionState.isAutomaticReplyEnabled =
        mailboxAutoReplyConfigurationOptions.AutoReplyState === 1 /* Enabled */ ||
            mailboxAutoReplyConfigurationOptions.AutoReplyState === 2 /* Scheduled */;
    optionState.periodicReplyEnabled =
        mailboxAutoReplyConfigurationOptions.AutoReplyState === 2 /* Scheduled */;
    optionState.blockCalendarEnabled = mailboxAutoReplyConfigurationOptions.CreateOOFEvent;
    optionState.blockCalendarTitle = mailboxAutoReplyConfigurationOptions.OOFEventSubject;
    optionState.declineNewInvitationsEnabled =
        mailboxAutoReplyConfigurationOptions.AutoDeclineFutureRequestsWhenOOF;
    optionState.declineExistingCalendarEventsEnabled =
        mailboxAutoReplyConfigurationOptions.DeclineEventsForScheduledOOF;
    optionState.sendRepliesToContactsOnlyEnabled =
        mailboxAutoReplyConfigurationOptions.ExternalAudience === 1 /* Known */;
    optionState.sendRepliesOutsideOrgEnabled =
        mailboxAutoReplyConfigurationOptions.ExternalAudience === 1 /* Known */ ||
            mailboxAutoReplyConfigurationOptions.ExternalAudience === 2 /* All */;
    var isEnterpriseUser = !isConsumer();
    if (isEnterpriseUser) {
        optionState.editorViewStateMessage = createEditorViewState(mailboxAutoReplyConfigurationOptions.InternalMessage, false);
        optionState.editorViewStateOutsideOrg = createEditorViewState(mailboxAutoReplyConfigurationOptions.ExternalMessage, false);
    }
    else {
        optionState.editorViewStateMessage = createEditorViewState(mailboxAutoReplyConfigurationOptions.ExternalMessage, false);
    }
    // Check condition if the value can be null or empty string
    optionState.startDate = getDisplayDate(new Date(mailboxAutoReplyConfigurationOptions.StartTime));
    optionState.endDate = getDisplayDate(new Date(mailboxAutoReplyConfigurationOptions.EndTime));
    return optionState;
}
//# sourceMappingURL=parseMailboxAutoReplyConfiguration.js.map